export default {"src":"/uk/_next/static/media/Success.0a9bbe9d.svg","height":121,"width":121,"blurWidth":0,"blurHeight":0};